import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";
export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <h1>{props.data.city}</h1>
      <ul>
        <li>
          {" "}
          <FormattedDate date={props.data.date} />
        </li>
        <li className="text-capitalize">{props.data.description}</li>
      </ul>
      <div className="row mt-3">
        <div className="col-6">
          <div className="clearfix">
            <div className="d-flex">
              <WeatherIcon code={props.data.icon} size={56} />
              <WeatherTemperature celsius={props.data.temperature} />
            </div>
            {/* <img
              src={props.data.iconUrl}
              alt={props.data.description}
              className="float-left"
            /> */}

            {/* <span className="temperature">
                {Math.round(props.data.temperature)}{" "}
              </span>
              <span className="unit">° C</span> */}
          </div>
        </div>
        <div className="col-6">
          <ul>
            <li>Precipitation: 20%</li>
            <li> Humidity: {props.data.humidity} % </li>
            <li>Wind: {props.data.wind} km /h </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
